

import Transformer from './../transformer'

export default class ExtranetHighwayTransformer extends Transformer {
  static fetch({ id, name: nameInCatalog, slug, customer_name: customerName }) {
    const name = customerName
    return {
      id, name, nameInCatalog, slug, customerName 
    }
  }
}



// WEBPACK FOOTER //
// ./src/transformers/catalog/extranetHighway.js